import { memo, FC } from 'react';
import {
  MainNavigationHeader,
  // NavLogoWrapper,
} from 'components/BKJMainNavigation/BKJMainNavigation.styled';
// import { NavMenuIcon } from 'components/BKJMainNavigation/src/NavMenuIcon';
import { deepEquals } from 'utils/deepEquals';
import { INavHeaderProps } from 'components/BKJMainNavigation/src/NavHeader.types';
import { WhiteLabelLogo } from 'components/WhiteLabelLogo';
import { FillifyLogo } from 'components/WhiteLabelAssetComponents/Fillify/FillifyLogo';

const Component: FC<INavHeaderProps> = ({
  onMouseDown,
  isOpen,
  //  menuIcon
}) => {
  return (
    <MainNavigationHeader onMouseDown={onMouseDown}>
      {isOpen ? <WhiteLabelLogo /> : <FillifyLogo />}
    </MainNavigationHeader>
  );
};

export const WebNavHeader = memo(Component, deepEquals);
